import {Suspense} from "react";
import {useLazySection} from "@/Hooks/useLazySection";

export default function LazySection({children}) {
    const Component = children?.type;
    const [ref, visible] = useLazySection(Component);

    return (
        <div ref={ref}>
            {visible && (
                <Suspense fallback={null}>{children}</Suspense>
            )}
        </div>
    );
}
